import React from 'react'
import {Route, Switch, useRouteMatch} from 'react-router-dom'
import {useWallet} from 'use-wallet'

import chef from '../../assets/img/chef.png'

import Button from '../../components/Button'
import Page from '../../components/Page'
import PageHeader from '../../components/PageHeader'
import WalletProviderModal from '../../components/WalletProviderModal'

import useModal from '../../hooks/useModal'


import FarmCards from './components/FarmCards'
import {UserAccoutProvider} from "../../contexts/farm_provider/user_account_provider";

const FarmsAdmin: React.FC = () => {
    const {path} = useRouteMatch();
    const {account} = useWallet();
    const [onPresentWalletProviderModal] = useModal(<WalletProviderModal/>);
    return (
        <Switch>
            <Page>
                {!!account ? (
                    <>
                        <Route exact path={path}>
                            <PageHeader
                                icon={<img src={chef} height="120"/>}
                                subtitle="Nsure-Staking as an Underwriter(SaaU Game)"
                                title="Select Your Favorite Dishes"
                            />
                                <FarmCards/>
                        </Route>
                    </>
                ) : (
                    <div
                        style={{
                            alignItems: 'center',
                            display: 'flex',
                            flex: 1,
                            justifyContent: 'center',
                        }}
                    >
                        <Button
                            onClick={onPresentWalletProviderModal}
                            text="🔓 Unlock Wallet"
                        />
                    </div>
                )}
            </Page>
        </Switch>
    )
};

export default FarmsAdmin
